import { defineMessages } from 'react-intl';

export const scope = 'Taco.reporting';

export default defineMessages({
  createReportingSuccess: {
    id: `${scope}.message.save.success`,
    defaultMessage: 'Create reporting successfully!',
  },
  createReportingError: {
    id: `${scope}.message.save.error`,
    defaultMessage: 'Cannot create reporting',
  },
  editReportingSuccess: {
    id: `${scope}.message.save.success`,
    defaultMessage: 'Update reporting successfully!',
  },
  editReportingError: {
    id: `${scope}.message.save.error`,
    defaultMessage: 'Cannot update reporting',
  },
  requiredNameMessage: {
    id: `${scope}.message.required.name`,
    defaultMessage: 'Please input reporting name',
  },
  saveReportingError: {
    id: `${scope}.message.save.error`,
    defaultMessage: 'Cannot save reporting',
  },
  allPopulatedFieldsMessage: {
    id: `${scope}.components.allPopulatedFieldsMessage`,
    defaultMessage:
      "You've selected to export all populated fields that contain data. Please click the 'Export' button to proceed with the export.",
  },
  allPopulatedFields: {
    id: `${scope}.components.allPopulatedFields`,
    defaultMessage: 'All populated',
  },
});
